<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-carousel height="200px" direction="vertical" class="banner-carousel">
          <el-carousel-item v-for="imgData in imgDatas" :key="imgData.id">
            <el-link :href="imgData.url" target="_blank" :underline="false">
              <el-image class="topimg" fit="cover" :src="imgData.banner"></el-image>
            </el-link>
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getBannerAPI } from '@/api'
export default {
  data () {
    return {
      imgDatas: []
    }
  },
  created () {
    // 获取banner
    this.getBannerFn()
  },
  methods: {

    // 获取banner
    
    async getBannerFn () {
      const res = await getBannerAPI()
      
      if (res.data && res.data.data) {
        this.imgDatas = res.data.data.map(card => {
          const serverAddress = this.$backurl
          const imagePath = card.banner
          // const banner = serverAddress + imagePath
          const banner = `${serverAddress.replace(/\/$/, '')}/${imagePath.replace(/^\//, '')}`; // 拼接完整 URL
          // console.log('Full image URL:', banner); // 打印完整 URL 进行验证
          return {
            ...card,
            banner
          }
        })
      } else {
        console.error('Error: Unexpected API response', res)
      }
    }

  }
}

</script>

<style scoped>
/* banner：宽度 100% 跟随 .main-content —— 而 .main-content 的宽度随列数变化
   （6 列 968 / 7 列 1144 / 8 列 1320，见 Home.vue），所以 banner 宽度自动与之同宽，
   首尾卡片始终贴齐 banner 左右缘。
   高度按设计比例 968:200 等比缩放 → 6 列时正好 968×200（设计尺寸），
   7/8 列时同步放大（1144×236.4 / 1320×272.7），窄屏（内容区不足 968）整体等比缩小，
   不裁切、不拉伸。
   （el-carousel 的 height prop 只能写成行内固定值，这里用 CSS 覆盖成 auto + aspect-ratio。） */
.banner-carousel {
  width: 100%;
  margin: 0 auto;
  height: auto !important;
  aspect-ratio: 968 / 200;
  border-radius: 12px;
  overflow: hidden;
}

/* 手机端用更扁的比例，避免 banner 占掉过多首屏高度 */
@media (max-width: 767px) {
  .banner-carousel {
    aspect-ratio: 968 / 140;
  }
}

.banner-carousel::v-deep .el-carousel__container {
  height: 100% !important;   /* 覆盖 el-carousel 通过 height prop 写入的 inline 高度 */
}

.banner-carousel::v-deep .el-carousel__item {
  width: 100% !important;
  height: 100% !important;
  border-radius: 12px;
}

/* 图片外层是 el-link(inline-flex,高度 auto)：不补 100% 尺寸的话，
   百分比高度链在这里断掉 → .el-image 高度退化为 auto →
   内层 <img> 的 height:100% 一并失效，图片只能按原始比例缩放(968×195.6)，
   banner 底部会留约 4px 空隙，看起来"没有完全填充" */
.banner-carousel::v-deep .el-link {
  display: block;
  width: 100%;
  height: 100%;
}

/* 内层 <img> 显式兜底：无 fit 时 Element 只给 width/height:100%，
   一旦父级高度不确定就会退化；这里同时锁死尺寸与 object-fit，
   保证图片铺满整个 banner（cover 不变形，仅裁掉极少量边缘） */
.banner-carousel::v-deep .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.topimg {
  width: 100%;
  height: 100%;
}
</style>
